import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import AppButon from '../AppButon/AppButon';
import CheckBox from '../CheckBox/CheckBox';
import {tokenSelector} from '../../../../../store/selectors';
import {
  getTermsAndConditionsForGcc,
  saveTermsAndConditionsForGcc,
} from '../../../../../store/actions/thunk';
import {ACCOUNT_CREATED_PAGE_URL, ACCOUNT_MANUAL_PAGE_URL} from '../../../../../constants';
import {getCrid} from '../../../../../../../myaccount/src/utils/redirectWithCrId';
import * as S from './Agreement.styles';

const Agreement = () => {
  const history = useHistory();
  const [disable, setDisable] = useState(true);
  const token = useSelector(tokenSelector);
  const dispatch = useDispatch();

  const [agreementData, setAgreementData] = useState(null);

  useEffect(() => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:tnc|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/agencykyc/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
    });
  }, []);

  const handleTnc = () => {
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:tnc|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/agencykyc/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_tnc_continue',
    });
    const data = {
      lang: 'eng',
      agreed_time: new Date().valueOf(),
    };
    setDisable(true);
    dispatch(
      saveTermsAndConditionsForGcc(
        data,
        token,
        saveAgreemntSuccessCallback,
        saveAgreemntSuccessCallback,
      ),
    );
  };

  const handleCheckBox = e => {
    const isChecked = e.target.checked;
    if (isChecked) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:tnc|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/agencykyc/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_tnc_selected',
      });
    } else {
      const evarStr = 'myPartner|signup|businessVerification|GSTN|unchecked';
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:tnc|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/agencykyc/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_tnc_deselected',
      });
    }
    setDisable(disable => !disable);
  };

  useEffect(() => {
    const data = {
      token: token,
    };
    dispatch(getTermsAndConditionsForGcc(data, token, successCallback, errorCallback));
  }, []);

  const successCallback = response => {
    setAgreementData(response);
  };

  const errorCallback = response => {
    setAgreementData(null);
    setDisable(false);
  };

  const saveAgreemntSuccessCallback = response => {
    const screen = response?.screen;
    setDisable(false);
    if (screen === 'verification') {
      history.push(`${ACCOUNT_CREATED_PAGE_URL}?crId=${getCrid()}`);
    } else if (screen === 'manual') {
      history.push(`${ACCOUNT_MANUAL_PAGE_URL}?crId=${getCrid()}`);
    }
  };

  return (
    agreementData && (
      <React.Fragment>
        <S.Container>
          <div dangerouslySetInnerHTML={{__html: agreementData?.data_eng?.html_data}} />
          <S.Para>
            <CheckBox id={'tnc'} onChange={handleCheckBox}>
              <S.TncText>I have read and agree to the Terms and Conditions</S.TncText>
            </CheckBox>
          </S.Para>
        </S.Container>
        <AppButon
          buttonText={'Create account'}
          isDisabled={disable}
          onPress={handleTnc}
          isError={false}
          classes={''}
          butonWidth="40px"
        />
      </React.Fragment>
    )
  );
};

export default Agreement;
